






import { store } from '@/utils/store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CallButton extends Vue {
  @Prop({ required: true }) id!: string

  call() {
    store.callRequest(this.id);
  }
}
